export default class IndexTabControl extends HTMLButtonElement {
    constructor() {
        super();
    }

    connectedCallback() {
        this.addEventListener('click',  function(e){
            var href = this.dataset.href;

            if (href) {
                window.location.href = href;
            }
        });
    }
}
